export default __webpack_public_path__ + "static/media/pantry1-afterH-1440w.49aa53f8.avif";